import styled from 'styled-components';
import { SwitchContainer } from '../../../ui/SwitchContainer';
import { httpApi } from '@nucleus-care/nucleuscare-backend-client';
import { useEffect, useState } from 'react';
import { AccountApi } from '../../../sources/accountApi';

const MainContainer = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px;
  gap: 10px;
`;

interface IAccountFeatures {
  EnablePatientGroups: boolean;
  EnablePostCallNotes: boolean;
  EnableInCallNotification: boolean;
}

export const AccountFeatures = ({
  accountId,
}: {
  accountId: string;
}) => {

  const [patientGroupEnabled, setPatientGroupEnabled] = useState<boolean>(false);
  const [postCallNotesEnabled, setPostCallNotesEnabled] = useState<boolean>(false);
  const [accountFeatures, setAccountFeatures] = useState<IAccountFeatures | null>(null);
  const [loadingFeatures, setLoadingFeatures] = useState<boolean>(true);
  const getFeatures = async () => {
    setLoadingFeatures(true);
    const { data } = await AccountApi.getFeatures({ accountId });
    console.log('data getFeatures', data);
    setLoadingFeatures(false);
    setAccountFeatures(data);
  }

  const togglePatientGroups =  async (state: boolean) => {
    try{
      await AccountApi.togglePatientGroups({ accountId, state });
    }catch(e){
      console.warn('Error toggling feature', e);
    }
  }
  const togglePostCallNotes =  async (state: boolean) => {
    try{
      await AccountApi.togglePostCallNotes({ accountId, state });
    }catch(e){
      console.warn('Error toggling feature', e);
    }
  }
  const toggleInCallNotification =  async (state: boolean) => {
    try{
      await AccountApi.toggleInCallNotification({ accountId, state });
    }catch(e){
      console.warn('Error toggling feature', e);
    }
  }

  useEffect(() => {
    if(accountId){
      getFeatures();
    }
  }, [accountId]);


  return (
    <MainContainer>
      <Column>
        <SwitchContainer loading={loadingFeatures} label="Enable Patient Groups" onChange={(state: boolean) => {
          togglePatientGroups(state);
          setAccountFeatures((prev) => prev ? { ...prev, EnablePatientGroups: state } : null);
        }} checked={accountFeatures?.EnablePatientGroups} />

        <SwitchContainer loading={loadingFeatures} label="Enable In Call Notification" onChange={(state: boolean) => {
          toggleInCallNotification(state);
          setAccountFeatures((prev) => prev ? { ...prev, EnableInCallNotification: state } : null);
        }} checked={accountFeatures?.EnableInCallNotification} />

        <SwitchContainer loading={loadingFeatures} label="Enable Post Call Notes" onChange={(state: boolean) => {
          togglePostCallNotes(state);
          setAccountFeatures((prev) => prev ? { ...prev, EnablePostCallNotes: state } : null);
        }} checked={accountFeatures?.EnablePostCallNotes} />
      </Column>
    </MainContainer>
  );
};
